// Shared "take me to pricing" intent detector.
//
// Lives in its own leaf module (NOT router/index.js) so both the navigation
// guard and Home.vue can import it without creating an import cycle. When this
// lived in router/index.js, Home.vue's `import { wantsPricing } from '@/router'`
// formed a cycle (router → Home → router) that left the binding undefined at
// guard-execution time, so the signed-in pricing carve-out silently never fired.
export function wantsPricing(route) {
  return route?.query?.pricing === '1' || route?.hash === '#pricing';
}
